/* global oovvuuRuntime */

import React, { useEffect, memo } from 'react'
import { x } from '@xstyled/styled-components'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch (error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className='row mt-20'>Something went wrong.</div>
    }

    return this.props.children
  }
}

const Oovvuu = memo(({uuid}) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.oovvuuRuntime === 'function') {
      oovvuuRuntime()
    }
  }, [uuid])

  return (
    <x.div w='100%' maxWidth={1220} mx='auto' mt={20} mb={20}>
      <x.div data-oovvuu-embed={uuid} w='100%'>
        <amp-iframe src={'https://playback.oovvuu.media/frame/' + uuid} width={5} height={4} sandbox='allow-scripts allow-same-origin' layout='responsive' frameborder='0' resizable>
          <x.div overflow='true' placeholder='true' />
        </amp-iframe>
      </x.div>
    </x.div>)
})
export default Oovvuu
export { ErrorBoundary }
